module.exports = __webpack_public_path__ + "static/media/СЗФО_2010.feb79f7e.png";